import React, { useContext, useEffect, useRef, useState } from 'react';

import { useTranslation } from "react-i18next";
import { DataGrid } from '@mui/x-data-grid';

import {API, getCountries} from '../services/api';
import jwtInterceoptor from '../components/shared/jwtInterceptor';

import { date_formats } from '../services/data';

import moment from 'moment';

import Swal from 'sweetalert2';
import OrgContext from '../organisation/OrgContext';
import GoBack from "../components/goBack";

import { host } from '../services/api';

function InvoiceModelsList(props) {

    const [t, i18n] = useTranslation();

    const { organisation, changeOrg } = useContext(OrgContext);

    const [models, setModels] = useState([]);

    const [currentModel, setCurrentModel] = useState(organisation.invoice_model_id);


    useEffect(()=>{

        const fetchModels = async () => {
            const response = await jwtInterceoptor.get("/data/invoices/models");

            if(response.status === 200){
                setModels(response.data.data);
            }
        };

        fetchModels();
        
    }, []);

    const changeModel = async (model) => {
        if(model){
            try {
                const response = await jwtInterceoptor.post(`/data/invoices/models/change`, {
                    model_id: model.id,
                    organisation_id: organisation?.id
                });
                if(response.status == 200){
                    if(response.data.status == true){
                        //let org = organisation;
                        organisation.invoice_model_id = model.id;
                        changeOrg(organisation);
                        setCurrentModel(model.id);
                        Swal.fire({
                            icon: 'success',
                            text: t(response.data.message),
                        });
                        console.log(organisation);
                        setModels(models);
                        
                    }else{
                        Swal.fire({
                            icon: 'warning',
                            title: 'Oops...',
                            text: t(response.data.message),
                        });
                    }
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title: 'Oops...',
                        text: t('Something went wrong!, try again'),
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Oops...',
                    text: t('Something went wrong!, try again'),
                });
            }
        }
    }

    return (
        <>
            <div className="row" >
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header container-fluid row">
                            <div className="col-md-9 col-sm-12 card-title">{t("Modèle de facture")}</div>
                        </div>
                        <div className="card-body">
                        {!currentModel && (
    <div className="alert alert-warning" role="alert">
        {t("Aucun modèle de facture n'est actuellement sélectionné.")}
    </div>
)}
                            <div className='row'>
                                {models.map(model => <div className="col-xl-4 col-md-6">
                                        <div className="card overflow-hidden">
                                            <img src={`${host}/${model.preview}`} className="card-img-top" alt="img" height="400px" width="100%" />
                                            <div className="card-body">
                                                <h5 className="card-title">{model.name}</h5>
                                                
                                                {currentModel == model.id ?
                                                (
                                                    <button disabled  className="btn btn-primary">{t("Ceci le modèle actif")}</button>
                                                ):
                                                (
                                                    <button onClick={() => {
                                                        changeModel(model);
                                                    }} className="btn btn-primary">{t("Utilisez ceci")}</button>
                                                )}
                                                
                                            </div>
                                        </div>
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default InvoiceModelsList;